
import { View } from 'backbone';
import { Model } from 'backbone';
import listService  from 'ListService.js';
import Template from 'behaviors/properties/main/get-field-from.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
//=====================================================================
//
// An instance of this view represents a get field from.
//
// Casey Justus, May 30, 2016
//
//=====================================================================

class MainGetFieldFromView extends View {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'click #targetField'             : 'launchModal'
        };


        if (this.model.get('fieldId')) {
            const id = listService.cleanId(this.model.get('fieldId'));
            const obj = listService.getObject(id);
            let targetFieldName = obj ? obj.model.get('name') : listService.determineFieldName(id);
            this.model.set('targetFieldName', targetFieldName, {silent: true});
        }


        //this.listenTo(this.model, 'change', this.render);

        return this;
    }

    launchModal(ev){
        ev.preventDefault();
        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get("fieldId"), {silent:true});
        
        var sfModal = new selectFieldModal({model: sfModel});
        sfModal.render().then((selectedField)=>{
            // used only for display in the UI
            this.model.set('targetFieldName', selectedField.name, {silent: true});
            this.model.set('fieldId', selectedField.id, {silent: true});
            this.render();
        });
    }

    render() {

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainGetFieldFromView;
